"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { cx } from "../internal/cx.js";
import { IconCheck } from "../internal/icons.js";
/** Material 3 switch: an on/off setting that applies at once (role=switch). For choices that need «Save», use a checkbox. */
export function Switch({ checked, onChange, label, hideLabel, disabled, icon, labelFirst, id, title, className }) {
    const auto = useId();
    const switchId = id ?? auto;
    const text = _jsx("label", { htmlFor: switchId, className: hideLabel ? "jui-sr-only" : "jui-switch-label", children: label });
    return _jsxs("span", { className: cx("jui-switch-field", disabled && "jui-switch-field--disabled", className), title: title, children: [labelFirst && text, _jsx("button", { id: switchId, type: "button", role: "switch", "aria-checked": checked, disabled: disabled, className: "jui-switch", onClick: () => onChange(!checked), children: _jsx("span", { className: "jui-switch-handle", children: icon && checked && _jsx(IconCheck, {}) }) }), !labelFirst && text] });
}
